<template>
  <b-row>
    <b-col cols="12">
        <l-map
            ref="mymap"
            :zoom="zoom"
            :center="[latitude, longitude]"
        >
          <l-tile-layer :url="url"/>
          <l-marker :lat-lng="[latitude, longitude, {draggable: 'false'}]">
            <l-popup>You're here!</l-popup>
          </l-marker>
        </l-map>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCol, BRow
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LPopup,
} from 'vue2-leaflet'

export default {
  components: {
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    BRow
  },
  props: {
    longitude: {
      required: true,
    },
    latitude: {
      default: true,
    },
  },
  data() {
    return {
      map: null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 15,
    }
  },
  methods: {
    refreshMap() {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 500);
    }
  },
  watch: {
    longitude: {
      deep: true,
      handler(val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            //mapObject is a property that is part of leaflet
            this.$refs.mymap.mapObject.invalidateSize();
          }, 100);
        }
      }
    },
    latitude: {
      deep: true,
      handler(val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            //mapObject is a property that is part of leaflet
            this.$refs.mymap.mapObject.invalidateSize();
          }, 100);
        }
      }
    }
  },
  created() {
    this.refreshMap()
    this.$parent.$on('refreshMap', this.refreshMap);
  },
  beforeDestroy() {
    this.$parent.$off('refreshMap');
  },
  mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.mymap.mapObject;
    });
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/map-leaflet.scss';

.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>

<style scoped>
@import "https://unpkg.com/leaflet@1.2.0/dist/leaflet.css";
</style>


